import { MinusIcon, PlusIcon, CancelIcon } from '@/components/icons'
import country from 'country-list-js'
import { useMemo } from 'react'
import Flag from 'react-flagpack'

const SelectedCountries = ({ countryStates, onRemoveCountry }) => {
    const allCountries = useMemo(() => {
        return Object.values(country.all)
    }, [])

    const getCountryByCode = (code) => {
        return allCountries.find((c) => c.iso2 === code)
    }

    const selectedCountries = useMemo(() => {
        const included = []
        const excluded = []

        countryStates.forEach((state, code) => {
            const countryData = getCountryByCode(code)
            if (countryData) {
                if (state === 'included') {
                    included.push({ ...countryData, state })
                } else if (state === 'excluded') {
                    excluded.push({ ...countryData, state })
                }
            }
        })

        return { included, excluded }
    }, [countryStates, allCountries])

    const handleRemove = (countryCode) => {
        onRemoveCountry(countryCode)
    }

    if (selectedCountries.included.length === 0 && selectedCountries.excluded.length === 0) {
        return (
            <div className="tw:flex tw:flex-wrap tw:gap-2 tw:p-2 tw:border tw:mx-3 tw:bg-background tw:rounded-xs">
                <div className="tw:inline-flex tw:items-center tw:gap-0.5 tw:px-2 tw:py-0.5 tw:rounded-full tw:text-sm tw:border tw:border-green-300 tw:max-h-[25px]">
                    <PlusIcon className="tw:w-4 tw:h-4 tw:text-green-300" />
                    <span className="tw:text-2xl">
                        <img src="/world.png" className="tw:size-4"></img>
                    </span>
                    <span className="tw:sm tw:mx-1">Worldwide</span>
                </div>
            </div>
        )
    }

    return (
        <div className="tw:flex tw:flex-wrap tw:gap-2 tw:p-2 tw:border tw:mx-3 tw:bg-background tw:rounded-xs">
            {selectedCountries.included.map((country) => (
                <div
                    key={`included-${country.iso2}`}
                    className="tw:inline-flex tw:items-center tw:gap-0.5 tw:px-2 tw:py-0.5 tw:rounded-full tw:text-sm tw:border tw:border-green-300 tw:max-h-[25px]"
                >
                    <PlusIcon className="tw:w-4 tw:h-4 tw:text-green-300" />
                    <span className="tw:text-2xl">
                        <Flag
                            code={country.iso3}
                            className="tw:!w-4 tw:!h-4 tw:!rounded-full tw:!object-cover"
                            hasBorder={false}
                        />
                    </span>
                    <span className="tw:sm tw:ml-1">{country.name}</span>
                    <button
                        onClick={() => handleRemove(country.iso2)}
                        className="hover:tw:text-white/50 tw:transition-colors tw:!ml-0.5"
                    >
                        <CancelIcon className="tw:w-5 tw:h-5" />
                    </button>
                </div>
            ))}
            {selectedCountries.excluded.map((country) => (
                <div
                    key={`excluded-${country.iso2}`}
                    className="tw:inline-flex tw:items-center tw:gap-1 tw:px-2 tw:py-0.5 tw:rounded-full tw:text-sm tw:border tw:border-red-300 tw:max-h-[25px]"
                >
                    <MinusIcon className="tw:w-4 tw:h-4 tw:text-red-300" />
                    <span className="tw:text-2xl">
                        <Flag
                            code={country.iso3}
                            className="tw:!w-4 tw:!h-4 tw:!rounded-full tw:!object-cover"
                            hasBorder={false}
                        />
                    </span>
                    <span className="tw:font-medium tw:ml-1">{country.name}</span>
                    <button
                        onClick={() => handleRemove(country.iso2)}
                        className="hover:tw:text-white/50 tw:transition-colors tw:!ml-0.5"
                    >
                        <CancelIcon className="tw:w-5 tw:h-5" />
                    </button>
                </div>
            ))}
        </div>
    )
}

export default SelectedCountries
